"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyToClipboard = copyToClipboard;
// copy using navigator.clipboard
function copyToClipboard(text) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
    }
    // fallback to old method
    const textArea = document.createElement("textarea");
    textArea.value = text;
}
//# sourceMappingURL=clipboard.js.map